export default "__VITE_ASSET__Dk3YzomJ__"